// Mock Quiz Data
import { useEffect, useState } from 'react';
import './quiz.css';
import { IoMdClose } from 'react-icons/io';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Button, Checkbox, Divider, Image, Spin } from 'antd';
import { getQuizDetail, postQuizResponse } from "../tatvaPedia/service";
import useStore from "../../store/useStore";
import { BsCheckCircleFill } from "react-icons/bs";
import { getDecodedToken } from "../../utils/localStorage";
import QuizSuccessImg from "../../assets/images/quiz-success.svg";
import { trackZymedEvent, ZYMED_EVENTS } from "../../utils/zymedAnalytics";


const TakeQuiz = () => {
    const navigate = useNavigate();
    const { tatvaPediaToken } = useStore();
    const getToken = () =>
        tatvaPediaToken || localStorage.getItem("tatvaPediaToken");
    const token = getToken();
    const [searchParams] = useSearchParams();
    const [loading, setLoading] = useState(true);
    const tokenData: any = getDecodedToken();
    const doctorDetails: any = tokenData?.user || {};
    const [quizResponse, setQuizResponse] = useState<any>([]);
    const [contentInfoId, setContentInfoId] = useState(Number(searchParams.get('contentInfoId')) || 0);

    const backBtnHandler = () => {
        navigate(-1);
    };

    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [selectedAnswers, setSelectedAnswers] = useState<any>([]);
    const [showResult, setShowResult] = useState(false);
    const [quizDetails, setQuizDetails] = useState<any>(null);

    const fetchQuizDetails = async () => {
        if (contentInfoId !== 0) {
            const res: any = await getQuizDetail(contentInfoId, token);
            if (res !== undefined && res?.body?.length > 0) {
                setQuizDetails(res.body[0]);
                trackZymedEvent(ZYMED_EVENTS.PEDIA_QUIZ_STARTED, {
                    quiz_id: res.body[0]?.id,
                });
                setLoading(false);
            }
        }
    }

    useEffect(() => {
        fetchQuizDetails();
    }, []);

    // Handle Answer Selection
    const handleAnswerSelect = (answer: any) => {
        trackZymedEvent(ZYMED_EVENTS.PEDIA_QUIZ_QUESTION_ANSWERED, {
            quiz_id: quizDetails?.id,
            question_number: currentQuestionIndex + 1,
            is_correct: !!answer?.is_correct,
        });
        const updatedAnswers: any = [...selectedAnswers];
        updatedAnswers[currentQuestionIndex] = answer;

        // Copy current quizResponse
        const updatedQuizResponse = [...quizResponse];

        const currentQuestionId = quizDetails?.questions[currentQuestionIndex]?.id;

        // Check if the question is already in the quizResponse
        const existingIndex = updatedQuizResponse.findIndex(
            (item) => item.id === currentQuestionId
        );

        if (existingIndex !== -1) {
            // Update existing answer
            updatedQuizResponse[existingIndex].options = [{ id: answer?.id }];
        } else {
            // Add new answer
            updatedQuizResponse.push({
                id: currentQuestionId,
                options: [{ id: answer?.id }]
            });
        }

        setQuizResponse(updatedQuizResponse);
        setSelectedAnswers(updatedAnswers);
    };

    const submitQuizResponse = async () => {
        // console.log(quizResponse);
        setLoading(true);
        const payload = {
            id: quizDetails?.id,
            questions: quizResponse
        };
        console.log(payload);

        const res: any = await postQuizResponse(payload, token);
        if (res !== undefined) {
            trackZymedEvent(ZYMED_EVENTS.PEDIA_QUIZ_COMPLETED, {
                quiz_id: quizDetails?.id,
                score: calculateScore(),
                total_questions: quizDetails?.questions?.length,
            });
            setLoading(false);
            setShowResult(true);
        }

    }

    // Handle Next Question
    const handleNextQuestion = async () => {
        if (currentQuestionIndex < quizDetails?.questions?.length - 1) {
            setCurrentQuestionIndex(currentQuestionIndex + 1);
        } else {
            // Show result after last question

            // submit the quiz response
            submitQuizResponse();

        }
    };

    // Handle Back Button
    const handleBackQuestion = () => {
        if (currentQuestionIndex > 0) {
            setCurrentQuestionIndex(currentQuestionIndex - 1);
        }
    };

    // Check if all questions are answered
    const isAllQuestionsAnswered = selectedAnswers.every((answer: any) => answer !== undefined);

    // Calculate Score
    const calculateScore = () => {
        let score = 0;
        quizDetails?.questions?.forEach((question: any, index: any) => {
            if (selectedAnswers[index]?.is_correct) {
                score++;
            }
        });
        return score;
    };

    // Render Quiz Questions
    const renderQuiz = () => {
        const currentQuestion: any = quizDetails?.questions[currentQuestionIndex];
        return (
            <>
                <div className="flex bg-[#f5f5f5] flex-col items-start p-6 overflow-y-auto"
                    style={{ height: 'calc(100vh - 12.5rem)' }}>
                    <div className='mobile-container'>
                        <h2 className='font-semibold text-[#454551]'>{currentQuestion?.question_text}</h2>
                        <ul>
                            {currentQuestion.options.map((option: any, index: any) => (
                                <li key={'option' + option?.id}>
                                    <label>
                                        <Checkbox
                                            style={{ borderColor: '#454551' }}
                                            className='mr-2 quiz-checkbox border-[#454551]'
                                            checked={selectedAnswers[currentQuestionIndex] === option}
                                            onChange={() => handleAnswerSelect(option)}
                                            value={option}
                                            name={`question-${currentQuestion.id}`}
                                        />

                                        <span
                                            className={selectedAnswers[currentQuestionIndex] === option ? 'text-[#4b4ad5] font-semibold' : ''}>
                                            {option?.option_text}</span>

                                    </label>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
                <div className="w-full absolute bottom-6 left-0">
                    <Divider />
                    <div className={'flex flex-row justify-center gap-2 w-full'}>
                        {currentQuestionIndex > 0 && (
                            <Button onClick={handleBackQuestion}
                                className="w-[85%] h-14 rounded-2xl p-5 text-lg font-medium text-indigo-600 bg-white whitespace-nowrap border border-indigo-600 border-solid">
                                Back
                            </Button>
                        )}
                        <Button
                            onClick={handleNextQuestion}
                            className="w-[85%] h-14 rounded-2xl bg-[#4B4AD5]  text-white p-5 text-lg font-medium"
                            disabled={!selectedAnswers[currentQuestionIndex]}
                        >
                            {currentQuestionIndex === quizDetails?.questions?.length - 1 ? "Finish" : "Next"}
                        </Button>
                    </div>
                </div>
            </>
        )
            ;
    };

    // Render Result Screen
    const renderResult = () => {
        const score = calculateScore();
        const totalQuestions = quizDetails?.questions?.length;
        const percentage = ((score / totalQuestions) * 100).toFixed(2);

        return (
            <div className="result-container">
                <div className="result-icon">
                    <svg viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="25" cy="25" r="25" fill="#28C76F" />
                        <path
                            d="M19.5 25L25 30.5L30.5 25L25 19.5L19.5 25Z"
                            fill="white"
                        />
                    </svg>
                </div>
                <h2>Congratulations!</h2>
                <p>
                    You scored {score} out of {totalQuestions} ({percentage}%)
                </p>
                <p>Great job! You did it!</p>
            </div>
        );
    };


    const renderResult2 = () => {
        return <div className="flex flex-col items-center justify-center bg-[#f5f5f5] text-center px-4"
            style={{ height: 'calc(100vh - 8rem)' }}>
            <Image src={QuizSuccessImg} alt={"Quiz Success"} preview={false}/>
            {/*<div className="bg-green-400 rounded-full p-6 mb-6">
                <BsCheckCircleFill className="text-white text-5xl" />
            </div>*/}

            <h1 className="text-2xl font-semibold text-gray-800">Congratulation</h1>
            <p className="text-sm text-gray-600 mt-1">Great job, {doctorDetails?.name.split(" ")[1]}! You Did It</p>
        </div>
    };

    return (

        <div className="flex flex-col justify-between h-full">
            <div className="flex flex-row items-start p-6">
                <IoMdClose onClick={() => backBtnHandler()} className='mt-1 mr-2 cursor-pointer' />
                <span>Quiz</span>
            </div>
            {loading ? <><Spin className="flex items-center justify-center h-screen" /></> : <>
                {/* Add progress bar here with question no */}
               {!showResult && <div className='flex flex-col self-center w-full px-6'>
                    <p className='text-sm'>
                        <span
                            className='text-[#4b4ad5]'>Question {currentQuestionIndex + 1}</span> of {quizDetails?.questions?.length}
                    </p>
                    <progress
                        value={currentQuestionIndex + 1} max={quizDetails?.questions?.length}
                        className="w-full quiz-progressbar border-radius-50 rounded-full bg-[#e4e7eb] h-1"
                    />
                </div>}
                {showResult ? renderResult2() : renderQuiz()}
            </>}
        </div>
    );
}

export default TakeQuiz;